import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleCheck,
  faCircleInfo,
  faClockRotateLeft,
  faLocationCrosshairs,
} from '@fortawesome/pro-regular-svg-icons';
import { Text } from '@querodelivery/uni-react';
import styles from './map-overlay-chips.module.scss';

interface OverlayStatusMessage {
  title: string;
  description?: string;
}

interface MapOverlayChipsParams {
  onCenter: () => void;
  unavailableMessage?: OverlayStatusMessage | null;
  deliveredMessage?: OverlayStatusMessage | null;
  isRetentionExpired?: boolean;
}

export const MapOverlayChips = ({
  onCenter,
  unavailableMessage,
  deliveredMessage,
  isRetentionExpired = false,
}: MapOverlayChipsParams) => {
  return (
    <>
      {(deliveredMessage || unavailableMessage) && (
        <div className={styles.statusOverlay}>
          {deliveredMessage && (
            <div className={styles.statusChip}>
              <FontAwesomeIcon icon={faCircleCheck} className={styles.icon} />
              <span className={styles.summaryText}>
                <Text
                  as="span"
                  fontSize="xs"
                  fontWeight="semibold"
                  tone="secondary"
                >
                  {deliveredMessage.title}
                </Text>
                {deliveredMessage.description && (
                  <Text as="span" fontSize="xxs" tone="supporting">
                    {deliveredMessage.description}
                  </Text>
                )}
              </span>
            </div>
          )}
          {unavailableMessage && (
            <div className={`${styles.statusChip} ${styles.unavailable}`}>
              <FontAwesomeIcon
                icon={isRetentionExpired ? faClockRotateLeft : faCircleInfo}
                className={styles.icon}
              />
              <span className={styles.summaryText}>
                <Text
                  as="span"
                  fontSize="xs"
                  fontWeight="semibold"
                  tone="secondary"
                >
                  {unavailableMessage.title}
                </Text>
                <Text as="span" fontSize="xxs" tone="supporting">
                  {unavailableMessage.description}
                </Text>
              </span>
            </div>
          )}
        </div>
      )}

      <div className={styles.overlay}>
        <button
          type="button"
          className={styles.centerButton}
          onClick={onCenter}
        >
          <FontAwesomeIcon
            icon={faLocationCrosshairs}
            className={styles.icon}
          />
          <Text as="span" fontSize="xs" fontWeight="semibold" tone="secondary">
            Centralizar
          </Text>
        </button>
      </div>
    </>
  );
};
